import { Constants } from "../constants/constants";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";

import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import Swal from "sweetalert2/dist/sweetalert2.all.js"; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { Utils } from "../utils/utils";

@Injectable({
  providedIn: "root",
})
export class GestionVendedorCarteraService {
  constructor(private http: HttpClient, private utils: Utils) {}

  public getGestionVendedorRecaudo(
    idUsuario,
    agencia,
    fechaInicial,
    fechaFinal,
    idUsuarioConsulta,
    idDistribuidora
  ): Observable<any> {
    const url =
      Constants.BASE_URL +
      Constants.URL_GESTION_VENDEDOR_CARTERA +
      "/" +
      idUsuario +
      "/" +
      agencia +
      "/" +
      fechaInicial +
      "/" +
      fechaFinal +
      "/" +
      idUsuarioConsulta +
      "/" +
      idDistribuidora;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError((err) => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Gestión Vendedor",
            text: "Error Cargando Gestión Vendedor.",
            icon: "error",
          });
        }

        return throwError(err);
      })
    );
  }

  public getDetalleRecaudo(idEncabezado): Observable<any> {
    const url =
      Constants.BASE_URL +
      Constants.URL_GESTION_VENDEDOR_CARTERA +
      "/" +
      idEncabezado;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError((err) => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Gestión Vendedor",
            text: "Error Cargando Detalle Pedido.",
            icon: "error",
          });
        }

        return throwError(err);
      })
    );
  }

  public getConsultarRecaudo(idPedido, origen): Observable<any> {
    const url =
      Constants.BASE_URL +
      Constants.URL_GESTION_VENDEDOR_CARTERA +
      "/" +
      idPedido +
      "/" +
      origen;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError((err) => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Picking",
            text: "Error Consultando Picking.",
            icon: "error",
          });
        }
        return throwError(err);
      })
    );
  }
}
